import dayjs from '../dayjs';
import { Schedule } from '../model/schedule';

const DATE_FMT = 'YYYYMMDD';

const toSchedule = (schedule) => schedule instanceof Schedule ? schedule : new Schedule(schedule);

export const getRunningDatesForRange = (schedule, schedulesMap = {}, start, end) => {
    const s = toSchedule(schedule);
    const startDay = dayjs.isDayjs(start) ? start : dayjs(start);
    const endDay = dayjs.isDayjs(end) ? end : dayjs(end);
    const maxDays = Math.max(0, endDay.diff(startDay, 'day')) + 1;
    const dates = s.getRunningDates(startDay, maxDays, schedulesMap) || [];
    return new Set(dates.map(d => (dayjs.isDayjs(d) ? d : dayjs(d)).format(DATE_FMT)));
};

export const getRunningDateListForRange = (schedule, schedulesMap = {}, start, end) => {
    const set = getRunningDatesForRange(schedule, schedulesMap, start, end);
    return Array.from(set).map(s => dayjs(s, DATE_FMT));
};

export const buildServiceCalendar = (schedule, schedulesMap = {}) => {
    const s = toSchedule(schedule);
    const firstActive = s.getFirstActiveDate();
    const lastActive = s.getLastActiveDate();
    if (!firstActive || !lastActive) return null;

    const truthSet = getRunningDatesForRange(s, schedulesMap, firstActive, lastActive);

    const cal = {
        service_id: s.scheduleId,
        start_date: firstActive.format(DATE_FMT),
        end_date: lastActive.format(DATE_FMT)
    };
    Object.keys(s.operatingDays || {}).forEach(opDay => cal[opDay] = s.operatingDays[opDay] ? 1 : 0);

    const calendarDates = [];
    for (let d = firstActive.clone(); d.isSameOrBefore(lastActive, 'day'); d = d.add(1, 'day')) {
        const dateStr = d.format(DATE_FMT);
        const isOperating = s.isOperatingDay(d);
        const isRunning = truthSet.has(dateStr);
        if (isOperating && !isRunning) {
            calendarDates.push({ service_id: s.scheduleId, date: dateStr, exception_type: 2 });
        } else if (!isOperating && isRunning) {
            calendarDates.push({ service_id: s.scheduleId, date: dateStr, exception_type: 1 });
        }
    }

    return { calendar: cal, calendarDates };
};


